// extracted by mini-css-extract-plugin
export default {"root":"UpdateButton_root__dkn7h","icon":"UpdateButton_icon__z9so2","rotate":"UpdateButton_rotate__ivRHI","idle":"UpdateButton_idle__-cJra"};